import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { datiBilancioBisDatiBilancioRules } from './dati-bilancio-bis-dati-bilancio.rules';
import { datiBilancioBisStatoPatrimonialeAttivoRules } from './dati-bilancio-bis-stato-patrimoniale-attivo.rules';
import { datiBilancioBisStatoPatrimonialePassivoRules } from './dati-bilancio-bis-stato-patrimoniale-passivo.rules';

export const DatiBilancioBisRules: FormGroupRules = {
    ...datiBilancioBisDatiBilancioRules,
    ...datiBilancioBisStatoPatrimonialeAttivoRules,
    ...datiBilancioBisStatoPatrimonialePassivoRules,
};

export const DatiBilancioBisFormValidators = [...Object.values(DatiBilancioBisRules)];
